export var InternalDateOrder = /*#__PURE__*/function (InternalDateOrder) {
  InternalDateOrder["DMY"] = "DMY";
  InternalDateOrder["YMD"] = "YMD";
  InternalDateOrder["MDY"] = "MDY";
  return InternalDateOrder;
}({});
export var InternalDateSeparator = /*#__PURE__*/function (InternalDateSeparator) {
  InternalDateSeparator["Slash"] = "/";
  InternalDateSeparator["Dot"] = ".";
  InternalDateSeparator["Dash"] = "-";
  InternalDateSeparator["Space"] = " ";
  return InternalDateSeparator;
}({});
export var InternalDateComponentType = /*#__PURE__*/function (InternalDateComponentType) {
  InternalDateComponentType[InternalDateComponentType["Date"] = 0] = "Date";
  InternalDateComponentType[InternalDateComponentType["Month"] = 1] = "Month";
  InternalDateComponentType[InternalDateComponentType["Year"] = 2] = "Year";
  InternalDateComponentType[InternalDateComponentType["All"] = 3] = "All";
  InternalDateComponentType[InternalDateComponentType["Separator"] = 4] = "Separator";
  return InternalDateComponentType;
}({});
export var InternalDateValidateCheck = /*#__PURE__*/function (InternalDateValidateCheck) {
  InternalDateValidateCheck[InternalDateValidateCheck["NotNull"] = 0] = "NotNull";
  InternalDateValidateCheck[InternalDateValidateCheck["Number"] = 1] = "Number";
  InternalDateValidateCheck[InternalDateValidateCheck["Limits"] = 2] = "Limits";
  InternalDateValidateCheck[InternalDateValidateCheck["Native"] = 3] = "Native";
  InternalDateValidateCheck[InternalDateValidateCheck["Range"] = 4] = "Range";
  return InternalDateValidateCheck;
}({});
export function isInternalDateValidateCheck(value) {
  return typeof value === 'number' && Object.values(InternalDateValidateCheck).includes(value);
}
export var InternalDateFirstDayWeek = /*#__PURE__*/function (InternalDateFirstDayWeek) {
  InternalDateFirstDayWeek[InternalDateFirstDayWeek["Monday"] = 0] = "Monday";
  InternalDateFirstDayWeek[InternalDateFirstDayWeek["Sunday"] = 1] = "Sunday";
  InternalDateFirstDayWeek[InternalDateFirstDayWeek["Saturday"] = 2] = "Saturday";
  return InternalDateFirstDayWeek;
}({});
export var InternalDateDayWeek = /*#__PURE__*/function (InternalDateDayWeek) {
  InternalDateDayWeek[InternalDateDayWeek["Monday"] = 1] = "Monday";
  InternalDateDayWeek[InternalDateDayWeek["Tuesday"] = 2] = "Tuesday";
  InternalDateDayWeek[InternalDateDayWeek["Wednesday"] = 3] = "Wednesday";
  InternalDateDayWeek[InternalDateDayWeek["Thursday"] = 4] = "Thursday";
  InternalDateDayWeek[InternalDateDayWeek["Friday"] = 5] = "Friday";
  InternalDateDayWeek[InternalDateDayWeek["Sunday"] = 6] = "Sunday";
  InternalDateDayWeek[InternalDateDayWeek["Saturday"] = 7] = "Saturday";
  return InternalDateDayWeek;
}({});